import axios from "axios";
import Header from "../../../components/Header";
import ModalItem from "../../../components/ModalItem";
import Filters from "../../../components/listFilters";
import FiltersV2 from "../../../components/listFiltersV2.vue";
import ModalError from "../../../components/ModalError";
import ModalSuccess from "../../../components/ModalSuccess";
import ModalLog from "../../../components/ModalLog";
import ModalConfirmItemDelete from "../../../components/ModalConfirmItemDelete";
import ListControls from "../../../components/listControls";
import ModalConfirm from "../../../components/ModalConfirm";
import {EventBus} from "@/eventBus";

// mixins
import {HwProgressBarMixin} from './hw-progress-bar-mixin';
import {TokenMixin} from './token-mixin';
import {UserStoredDataMixin} from './user-stored-data-mixin';
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";
import _ from "lodash";

let ListLogicMixin = {
    mixins: [
        HwProgressBarMixin,
        TokenMixin,
        UserStoredDataMixin,
        ErrorsMixin,
    ],
    components: {
        Header,
        ModalItem,
        Filters,
        FiltersV2,
        ModalError,
        ModalSuccess,
        ModalLog,
        ModalConfirmItemDelete,
        ListControls,
        ModalConfirm,
    },
    data() {
        return {
            error: '',
            cashInterval: null,
            tabActive: true,
            success: '',
            pageTitle: '',
            pageFilter: '',
            pageTotal: '',
            title: '',
            info: '',
            filter: [],
            filterValues: {},
            filterExact: [],
            filters: [],
            total: 0,
            login: '/login',
            show: false,
            limit: 1000,
            pageNumber: 1,
            sortField: 'id',
            loadFormat: 'xlsx',
            loading: 'loaded',
            moving: false,
            currentColumn: null,
            nextColumn: null,
            buttons: null,
            dataKeysForStore: ['limit', 'sortField'],
            movingSelection: false,

            confirmModalTitle: '',
            confirmModalMsg: '',
            apiMultyRemoveUrlTmp: '/api/manager/ip/delete',
            apiMultyDelete: '',
            selectedItemsList: [],
            selectedGroup: false,
            currentItemId: -1,
            pagePreview: '',
            apiUrl: '',
            apiCacheUrl: '/cache/api/merged/',
            apiDiscoverUrl: '/api/manager/monitor/start/discover',
            realColumns: [],
            selectValues: [],
        };
    },
    methods: {
        refresh(Ip) {
            const filters = [
                {
                    Condition: "=",
                    Data: {Ip},
                }
            ]
            axios.post(this.apiDiscoverUrl, filters, this.authRespConf()).catch(res => {
                this.errorHandle(res, true, true);
            })
        },
        rowClick(item, event) {
            let element = event.target;
            // for open dialog
            let dataField = element.getAttribute("data-field");
            if (dataField) {
                if (item[dataField] !== undefined) {
                    this.textareaData = item[dataField];
                    this.$modal.show('modalTextarea');
                }
            }
        },
        updateSelectedRowsInfo() {

        },
        selectedRowsCount() {
            this.updateSelectedRowsInfo();
            return this.itemsSelectedCount;
        },
        lastSelectedItemId() {
            for (let element in this.selectedItemsList) {
                if (typeof element === "string") {
                    if (this.selectedItemsList[element] && element !== 'idnull') {
                        return element.replace('id', '');
                    }
                }
            }
        },
        selectGroupAction() {
            let rows = document.getElementById('resizable-table').rows;
            if (this.selectedGroup) {
                Array.from(rows).forEach(function (row) {
                    this.selectedItemsList['id' + row.getAttribute("data-item-id")] = true;
                }, this);
            } else {
                Array.from(rows).forEach(function (row) {
                    this.selectedItemsList['id' + row.getAttribute("data-item-id")] = false;
                }, this);
            }
            this.updateSelectedRowsInfo();
        },
        selectItemAction(id, status) {
            console.log(id, status);
            this.updateSelectedRowsInfo();
        },
        getUnnamedFilter(data) {
            let condition;
            let field;
            let value;
            if (Object.prototype.hasOwnProperty.call(data, 'Data') &&
                Object.prototype.hasOwnProperty.call(data, 'Condition')) {
                condition = data['Condition'];
                field = Object.keys(data['Data'])[0];
                value = data['Data'][field];
            }
            let fieldExist = false;
            for (let filterIndex in this.filter) {
                if (Object.prototype.hasOwnProperty.call(this.filter[filterIndex], 'name')) {
                    if (field === this.filter[filterIndex].name) {
                        fieldExist = true;
                    }
                }
            }

            if (!fieldExist) {
                return ' ' + field + ' ' + condition + ' ' + value;
            }
            return '';
        },
        onRouteChange() {
            clearInterval(this.cashInterval)
            this.sortField = 'id';
            this.limit = 1000;
            this.queryFilter = [];
            this.filters = [];
            this.ApplyUserConfig();
            this.UpdateUserConfig();
            this.selectedItemsList = [];
            this.selectedGroup = false;
            if (this.pagePreview !== this.$route.path) {
                this.filterValues = {}
            }
            this.pagePreview = this.$route.path
        },
        button(buttonName) {
            if (this.buttons === null) {
                return;
            }
            if (
                this.buttons[buttonName] === undefined ||
                this.buttons[buttonName]["api"] === undefined ||
                this.buttons[buttonName]["class"] === "running"
            ) {
                return;
            }
            this.error = '';
            axios.post(this.buttons[buttonName]["api"],
                {
                    name: buttonName
                },
                this.authRespConf())
                .catch((err) => {
                    this.errorHandle(err, true, true);
                })
                .then(res => {
                    this.buttons[buttonName]["class"] = "running";
                    if (res !== null && res !== undefined) {
                        this.info = 'Running';
                        setTimeout(this.clearInfo, 5000);
                        setTimeout(this.checkButtonsStatus, 2000);
                    }
                })
        },
        clearInfo() {
            this.info = '';
        },
        fillTemplate(tmp, itemFields) {
            for (let field in itemFields) {
                let replacedData = itemFields[field];
                if (replacedData === null || replacedData === undefined || replacedData === 'null') {
                    replacedData = '';
                }
                tmp = tmp.replaceAll("##" + field + "##", replacedData)
            }
            for (let field in itemFields) {
                tmp = tmp.replaceAll("##" + field + "#shorted##", String(itemFields[field]).substring(0, 400) + "...")
            }
            let matches = [...tmp.matchAll(/##to_low_deep_trim@([^#]*?)##/g)];
            let processedString = '';
            // replace something like this "##to_low_deep_trim@MY VALUE##" to "my-value"
            for (const match of matches) {
                if (match.length === 2) {
                    processedString = match[1].replace(' ', '-').toLocaleLowerCase();
                    tmp = tmp.replaceAll(match[0], processedString)
                }
            }
            return tmp
        },
        checkButtonsStatus() {
            for (let buttonName in this.buttons) {
                if (this.buttons[buttonName]["class"] === "running") {
                    axios.post(this.buttons[buttonName]["apiStatus"],
                        {
                            name: buttonName
                        },
                        this.authRespConf())
                        .catch((err) => {
                            this.errorHandle(err, true, true);
                        })
                        .then(res => {
                            if (res !== null && res !== undefined) {
                                if (res.data != "") {
                                    if (res.data.data !== "processed") {
                                        this.buttons[buttonName]["class"] = "";

                                        this.getAndShowDiscoverLogs();
                                        this.LoadData();
                                        this.success = 'Script successfully finished!';
                                        this.$modal.show('listSuccess');
                                    } else {
                                        setTimeout(this.checkButtonsStatus, 2000);
                                    }
                                }
                            }
                        });
                }
            }
        },

        startLoading() {
            this.loading = 'loading';
        },
        endLoading() {
            this.loading = 'loaded';
        },

        openDeleteItemConfirmation(item) {
            this.confirmModalTitle = 'Confirm delete IP: ' + item.Address;
            this.currentItemId = parseInt(item.Id);
            this.$modal.show('confirmItemDelete');
        },
        openDeleteItemsConfirmation() {
            this.confirmModalTitle = 'Confirm delete items';
            this.confirmModalMsg =
                'Are you sure you want to delete ' +
                document.getElementsByClassName('selected').length +
                ' items?';
            this.$modal.show('confirm');
        },
        deletedItem() {
            this.endLoading();
            this.LoadData();
        },
        deletedItemErr(err) {
            this.endLoading();
            this.errorHandle(err, true, true);
        },
        moveUp() {
            window.scrollTo(0, 0);
        },
        getTrTag(element) {
            if (!element) return element;
            if (element.tagName.toLowerCase() !== 'tr') {
                if (!element) return element;
                element = element.parentElement;
                if (element.tagName.toLowerCase() !== 'tr') {
                    if (!element) return element;
                    element = element.parentElement;
                    if (element.tagName.toLowerCase() !== 'tr') {
                        element = element.parentElement;
                    }
                }
            }
            return element;
        },
        getStateOptionLabel(label) {
            if (label === 'OK') {
                return "🟢OK"
            } else if (label === 'poweredOn') {
                return "🟢ON"
            } else if (label === 'NO PING') {
                return "🔴NO PING"
            } else if (label === 'poweredOff') {
                return "🔴OFF"
            } else if (label === 'UNKNOWN') {
                return "🤷‍UNKNOWN"
            } else if (label === 'DESTROYED') {
                return "🚫DESTROYED"
            } else if (label === 'CREATED') {
                return "🚀CREATED"
            } else if (label === 'CHANGED') {
                return "⚠️CHANGED"
            } else if (label === 'MOVE_PENDING') {
                return "🔜MOVE_PENDING"
            } else if (label === 'suspended') {
                return "⏸️SUSPENDED"
            } else if (label === null) {
                return "0️⃣NULL"
            }
            return label
        },
        filterChanged(resultFilter) {
            this.filters = resultFilter;
            this.pageNumber = 1;
            if (this.$route.query.page != undefined) {
                history.pushState({}, null, `#${this.$route.path}`);
            }
            this.selectedItemsList = [];
            this.selectedGroup = false;
            this.LoadData();
        },
        filterInit(resultFilter) {
            this.filters = resultFilter;
        },
        SortInvert(field) {
            if (field == this.sortField) {
                this.sortField = '-' + field
            } else {
                this.sortField = field
            }
            this.show = !this.show;
            this.UpdateUserConfig();
            this.LoadData();
        },
        filterPreparing() {
            for (let filter in this.filter) {
                if (this.filter[filter]['type'] === 'select') {
                    this.filterExact.push(this.filter[filter]['name'])
                }
                if (this.filter[filter]["external"] !== undefined) {
                    if (this.filter[filter]["external"]["url"] === undefined || this.filter[filter]["external"]["url"] === "") {
                        continue;
                    }
                    let request
                    if (this.filter[filter]["external"]["method"] && this.filter[filter]["external"]['method'] === 'get') {
                        request = axios.get(this.filter[filter]["external"]["url"], this.authRespConf())
                    } else {
                        request = axios.post(this.filter[filter]["external"]["url"], [], this.authRespConf())
                    }

                    request.then(res => {
                        if (res === undefined || res === null) {
                            return;
                        }
                        if (res.data.data !== undefined) {
                            _.forEach(res.data.data, (value, key) => {
                                if (this.filter[filter]["external"]["fieldValue"]) {
                                    this.filter[filter]["options"].push({
                                        value: value[this.filter[filter]["external"]["fieldValue"]],
                                        text: value[this.filter[filter]["external"]["fieldText"]],
                                    });
                                } else if (this.filter[filter].name === 'Entity') {
                                    this.filter[filter]["options"].push({
                                        value: key,
                                        text: value,
                                    });
                                } else {
                                    this.filter[filter]["options"].push({
                                        value: value,
                                        text: value,
                                    });
                                }
                            })
                        }
                    });
                }
            }
        },
        ChangeLimit(newLimit) {
            this.limit = newLimit;
            this.UpdateUserConfig();
            this.LoadData();
        },
        itemSuccess() {
            this.$modal.hide('editItem');
            this.$modal.hide('createItem');
            this.$modal.hide('DcCreate');
            this.$modal.hide('DcEdit');
            this.LoadData();
        },
        linkItem(templateUrl, item) {
            let url = this.fillTemplate(templateUrl, item);
            this.$router.push({path: url});
        },
        modalConfirmEvent(data) {
            if (data['button'] === 'delete') {
                this.removeSelected();
            }
            this.selectedItemsList = []
            this.$modal.hide('confirm');
        },
        removeSelected() {
            let itemsIds = [];
            let itemsOfSelected = document.getElementsByClassName('selected');
            for (let item of itemsOfSelected) {
                itemsIds.push(parseInt(item.getAttribute("data-item-id")));
            }
            this.removeItemsList(itemsIds);
        },
        removeItemsList(itemsIds) {
            axios.post(this.apiMultyDelete,
                itemsIds,
                this.authRespConf())
                .catch((err) => {
                    this.unselectItemsList(itemsIds);
                    this.errorHandle(err, true, true);
                })
                .then(res => {
                    if (res !== null && res !== undefined) {
                        Array.from(document.getElementsByClassName('selected')).forEach(function (el) {
                            el.classList.remove('selected');
                        });
                        this.unselectItemsList(itemsIds);
                        this.LoadData();
                        setTimeout(this.updateSelectedRowsInfo, 400);
                    }
                });
        },
        unselectItemsList(itemsIds) {
            for (let id of itemsIds) {
                const index = this.selectedItemsList.indexOf(id);
                if (index > -1) { // only splice array when item is found
                    this.selectedItemsList.splice(index, 1); // 2nd parameter means remove one item only
                }
            }
            this.updateSelectedRowsInfo();
        },
        newItemForm() {
            this.currentNewItemId = 0;
            this.$modal.show('createItem');
        },
        filterQuery() {
            if (!this.$route.query.filter) {
                return;
            }
            this.queryFilter = JSON.parse(this.$route.query.filter);
            if (this.queryFilter === undefined || this.queryFilter === null || this.queryFilter === '') {
                return;
            }
            if (this.queryFilter.length === 0) {
                return;
            }
            if (this.queryFilter) {
                if (Object.keys(this.queryFilter || {}).length === 0) {
                    for (let FieldName in this.filterValues) {
                        this.filterValues[FieldName] = '';
                    }
                }
                for (let filterIdx in this.queryFilter) {
                    let data = {};
                    if (!this.queryFilter[filterIdx].Data || !this.queryFilter[filterIdx].Condition) {
                        continue;
                    }
                    let condition = this.queryFilter[filterIdx].Condition;
                    let field;
                    let value;
                    for (let fieldName in this.queryFilter[filterIdx].Data) {
                        field = fieldName;
                        value = this.queryFilter[filterIdx].Data[fieldName];
                    }
                    if (value !== null && value !== undefined) {
                        this.filterValues[field] = value;
                    }
                    data[field] = value;
                    if (condition === '=') {
                        this.filterExact.push(field)
                    }
                    if (field === 'ssd/hdd') {
                        this.filters.push({
                            Group: {
                                Operator: "or",
                                FilterItems: [
                                    {
                                        Condition: condition,
                                        Data: {Hdd: data[field]}
                                    },
                                    {
                                        Condition: condition,
                                        Data: {Ssd: data[field]}
                                    }
                                ]
                            }
                        });
                    } else {
                        this.filters.push({
                            Condition: condition,
                            Data: data,
                        });
                    }
                }
            }
        },
        BeforeLoadData() {
            //can be replaces by local template implement
        },
        LoadData(loader = true) {
            this.dataLoader(loader)
        },
        dataLoader(showLoader = true) {
            this.BeforeLoadData();
            let loader
            if (showLoader) {
                loader = this.$loading.show();
            }
            this.error = '';
            axios.post(this.apiList + '?limit=' + this.limit + '&sort=' + this.sortField + '&page=' + this.pageNumber,
                this.filters,
                this.authRespConf())
                .catch((err) => {
                    if (showLoader) {
                        loader.hide();
                    }
                    this.errorHandle(err, true, true);
                })
                .then(res => {
                    if (showLoader) {
                        loader.hide();
                    }
                    console.log('loaded data');
                    this.items = res.data.data;
                    this.total = res.data.total;
                    setTimeout(this.updateSelectedRowsInfo, 400);
                    this.AfterLoadData();
                    this.sortItems();
                })
        },
        AfterLoadData() {
            //can be replaced by local template implement
        },
        downloadTable(showLoader = true) {
            this.BeforeLoadData();
            let loader
            if (showLoader) {
                loader = this.$loading.show();
            }
            this.error = '';
            axios.post(this.apiList +
                '?limit=' + this.limit +
                '&sort=' + this.sortField +
                '&page=' + this.pageNumber +
                '&format=' + this.loadFormat,
                this.filters,
                {headers: this.authHeader(), responseType: 'blob'})
                .catch((err) => {
                    if (showLoader) {
                        loader.hide();
                    }
                    this.errorHandle(err, true, true);
                })
                .then(res => {
                    if (showLoader) {
                        loader.hide();
                    }
                    const blob = new Blob([res.data])
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = this.title + '(' + (new Date()).toLocaleString() + ' - ' + document.location.host + ').' + this.loadFormat
                    link.click()
                    URL.revokeObjectURL(link.href)
                })
        },
        getItemsIndex(id) {
            //const indexToUpdate = _.findIndex(this.items, {Id: item.Id})
            for (const index in this.items) {
                if (this.items[index].Id === id) {
                    return index;
                }
            }
            return -1;
        },
        checkEventItem(item) {
            if (item === undefined || item === null) {
                return false;
            }
            return !(this.items === undefined || this.items === null);
        },
        handleUpdate(item) {
            if (!this.checkEventItem(item)) {
                return;
            }
            const indexToUpdate = this.getItemsIndex(item.Id);
            this.$set(this.items, indexToUpdate, item);
        },
        handleAdd(item) {
            if (!this.checkEventItem(item)) {
                return;
            }
            if (item.Id > 0) {
                //this.items = {...this.items, {(this.items.length):item}}; // bad design, doesnt work for servers
                this.items.push(item);
                this.sortItems();
                return;
            }
            if (item.length > 0) {
                for (const itemKey in item) {
                    if (this.items.length === 0) {
                        this.items = [item[itemKey]]
                    } else {
                        this.items = {...this.items, ...item[itemKey]};
                    }
                }
                this.sortItems();
            }
        },
        sortItems() {
            //can be replaced by local template implement
        },
        handleDelete(item) {
            if (!this.checkEventItem(item)) {
                return;
            }
            const indexToDelete = _.findIndex(this.items, {Id: item})
            this.$delete(this.items, indexToDelete);
        },
        setTitleByFilters() {
            if (this.pageFilter === undefined || this.pageFilter === null) {
                console.log("var pageFilter not found, change title trigger has incorrect place");
                return;
            }
            if (this.title === undefined || this.title === null) {
                console.log("var title not found, change title trigger has incorrect place");
                return;
            }
            if (this.queryFilter === undefined || this.queryFilter === null) {
                console.log("queryFilter var queryFilter not found, change title trigger has incorrect place");
                return;
            }
            if (this.queryFilter.length === 0) {
                this.pageFilter = "";
            }
            let val = this.queryFilter;
            const $this = this
            let unnamedFilter = ""
            _.forEach(val, function (field) {
                unnamedFilter = unnamedFilter += '[' + $this.getUnnamedFilter(field) + '], '
            })
            if (unnamedFilter !== "") {
                this.pageFilter = ' for: [ ' + unnamedFilter + ' ]'
            }
        },
        setFilterValuesFromRoute() {
            if (this.selectValues === undefined || this.selectValues === null) {
                return;
            }

            for (let FieldName in this.filterValues) {
                if (this.filterValues[FieldName] !== undefined && this.filterValues[FieldName] !== null) {
                    this.selectValues[FieldName] = this.filterValues[FieldName];
                }
            }
        },
        modalsHide() {
            console.log("list modalsHide");
            this.$modal.hide('success');
            this.$modal.hide('confirm');
            this.$modal.hide('createItem');
            this.$modal.hide('editItem');
            this.$modal.hide('addUser');
        },
        sidebarMenuClickHandler() {
            this.queryFilter = [];
            this.filterValues = [];
            for (let FieldName in this.selectValues) {
                this.selectValues[FieldName] = "";
            }
            this.onRouteChange();
            this.filterQuery();
            this.LoadData();
            this.setTitleByFilters();
        },
        async copyText(text, e){
            console.error('copyText: ', text);
            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(text);
                    console.log('Content copied to clipboard standard');
                    if (e !== undefined && e !== null) {
                        if (e.target.tagName === "i" || e.target.tagName === "I") {
                            e.target.parentNode.classList.toggle('copied');
                            setTimeout(() => {
                                e.target.parentNode.classList.toggle('copied');
                            }, "5000");
                        } else {
                            e.target.classList.toggle('copied');
                            setTimeout(() => {
                                e.target.classList.toggle('copied');
                            }, "5000");
                        }
                    }
                } else {
                    const textArea = document.createElement("textarea");
                    textArea.value = text;

                    // Move textarea out of the viewport so it's not visible
                    textArea.style.position = "absolute";
                    textArea.style.left = "-999999px";

                    document.body.prepend(textArea);
                    textArea.select();

                    try {
                        document.execCommand('copy');
                        console.log('Content copied to clipboard alternative');
                        if (e !== undefined && e !== null) {
                            if (e.target.tagName === "i" || e.target.tagName === "I") {
                                e.target.parentNode.classList.toggle('copied');
                                setTimeout(() => {
                                    e.target.parentNode.classList.toggle('copied');
                                }, "5000");
                            } else {
                                e.target.classList.toggle('copied');
                                setTimeout(() => {
                                    e.target.classList.toggle('copied');
                                }, "5000");
                            }
                        }
                    } catch (error) {
                        console.error(error);
                    } finally {
                        textArea.remove();
                    }
                }
            } catch (err) {
                console.error('Failed to copy: ', err);
                if (e !== undefined && e !== null) {
                    if (e.target.tagName === "i" || e.target.tagName === "I") {
                        e.target.parentNode.classList.toggle('unoccupied');
                        setTimeout(() => {
                            e.target.parentNode.classList.toggle('unoccupied');
                        }, "5000");
                    } else {
                        e.target.classList.toggle('unoccupied');
                        setTimeout(() => {
                            e.target.classList.toggle('unoccupied');
                        }, "5000");
                    }
                }
            }
        },
    },
    computed: {
        isDataVisible() {
            if (this.loading === 'loading') {
                return false;
            } else {
                return true;
            }
        },

    },
    watch: {
        total: function () {
            this.pageTotal = ' (' + this.items.length + '/' + this.total + ') ';
        },
        items: function () {
            this.pageTotal = ' (' + this.items.length + '/' + this.total + ') ';
        }
    },
    created: function () {
        this.pagePreview = this.$route.path
        EventBus.$on("EscapeKeyDown", this.modalsHide);
        EventBus.$on("sidebar-menu-click", this.sidebarMenuClickHandler);
    },
    destroyed() {
        clearInterval(this.cashInterval)
        EventBus.$off("EscapeKeyDown", this.modalsHide);
        EventBus.$off("sidebar-menu-click", this.setTitleByFilters);
    },
    mounted() {
        this.ApplyUserConfig();
        // this.startSSE()
    },
    updated: function () {
        window.cacherThis = this;
    }
};

export {ListLogicMixin};